import Loader from "react-loader-spinner";
interface FallbackProps {
    isActive: boolean;
}

export function Fallback({ isActive }: FallbackProps) {


    return (
        <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
            <Loader
                type="Bars"
                color="#00619e"
                height={100}
                width={100}
                // timeout={30000}
                visible={isActive}
            />
        </div>
    )
}